import { StateMessage } from '@/components/shared/state-message';
import { getSvg } from '@/utils/get-svg';

export const EmptyState = () => (
  <StateMessage
    title="Você ainda não possui nenhuma regra para solicitação de reembolso associada a sua conta"
    description="As regras para solicitação de reembolso aparecerão aqui."
    image={getSvg('status_empty_refund.svg')}
  />
);
